import styled from '@emotion/styled';
import { memo } from 'react';
import { fill_vertical_cross_center } from '~/modules/AppLayout/FlexGridCss';
import { SimpleQuoteListInteractWithChart } from '~/modules/symbolQuote/simple';
import { useVirtualAccountHolding } from '~/modules/virtualExchange/useVirtualExchangeResource';
import { store } from '~/pages/heineken_template/_private/store';
import { VolumeFilter } from './VolumeFilter';
import { boleStock_store } from '../_private/boleStock_store';
export const StockScreener30minute = memo(function StockScreener30minute() {
    const kdSymbol = useVirtualAccountHolding('bole_stock')?.filter(datum => datum.qty === 1);
    return (<styleds.container>
      <SimpleQuoteListInteractWithChart data={kdSymbol?.map(position => position.symbol) ?? ['']} chart={store.charting} handleClick={event => {
            store.charting.changeInterval(30);
            boleStock_store.userLastFocusSymbol = event;
        }}/>
      <VolumeFilter />
    </styleds.container>);
});
const styleds = {
    container: styled.div `
    ${fill_vertical_cross_center};
    display: grid;
    grid-template-rows: calc(100% - 42px) 42px;
    gap: 2px;
  `,
};
